import type { FormResponse } from '~/interfaces/form';
import { isUuidString } from '~/utils/uuid';

/**
 * Extracts form responses from FormData.
 * Form question IDs are UUIDs, so we filter by UUID pattern.
 *
 * @param formData - The FormData object containing form fields
 * @returns Array of FormResponse objects
 */
export function extractFormResponses(formData: FormData): FormResponse[] {
  const formResponses: FormResponse[] = [];

  for (const [key, value] of formData.entries()) {
    if (isUuidString(key) && value?.toString()?.trim() !== '') {
      formResponses.push({
        question_id: key,
        answer: value.toString(),
      });
    }
  }

  return formResponses;
}

export function appendFormResponses(formData: FormData, responses: FormResponse[]): void {
  for (const response of responses) {
    formData.append(response.question_id, response.answer);
  }
}
